import React from 'react';
import {Input} from "@material-tailwind/react";
import {reemplaceValue} from "../../utils/textOptions";
import {CustomTypography} from "./CustomTypography";

interface CustomInputProps {
    label?: string;
    labelFixel?: boolean;
    placeholder?: string;
    type?: string;
    value?: string;
    error?: string;
    className?: string;
    classNameContent?: string;
    classNameError?: string;
    textSize?: string;
    disabled?: boolean;
    mandatory?: boolean;
    maxLength?: number;
    onChangeText?: (text: string) => void;
    testId?: string;
}

const CustomInput = ({
                         label,
                         labelFixel,
                         placeholder,
                         disabled,
                         mandatory,
                         type,
                         error,
                         className,
                         classNameContent,
                         classNameError,
                         textSize,
                         maxLength,
                         testId,
                         ...props
                     }: CustomInputProps) => {
    const handleInputChange = (event: any) => {
        return reemplaceValue(type, event.target.value, maxLength);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const {key} = event;
        const upperCaseKey = key.toUpperCase();

        if (
            (upperCaseKey < '0' || upperCaseKey > '9') && // Números
            upperCaseKey !== 'BACKSPACE' && // Backspace
            upperCaseKey !== 'DELETE' && // Delete
            upperCaseKey !== '-'
        ) {
            event.preventDefault();
        }
    };

    return (
        <div className={`custom-input-generic w-full grid grid-cols-1 ${classNameContent}`}>
            {(props?.value !== '' || labelFixel) &&
                <div className={'label labelCustom'}>
                    <span
                        className={
                            `${disabled ? 'text-colorDisabled' : 'text-labelColor'} labelCustom normal-case text-[10px] ${label ? 'bg-white' : ''} ml-[18px] px-1 rounded-[5px] ${mandatory ? 'mt-[-2px]' : ''}`
                        }
                    >
                        {label}{mandatory && <span className={'text-danger ml-[2px]'}>*</span>}
                    </span>
                </div>
            }
            <div className={`${(props?.value !== '' || labelFixel) ? 'input' : 'relative'}`}>
                <Input
                    data-testid={testId}
                    crossOrigin=''
                    type={type === 'integer' ? 'number' : ''}
                    placeholder={placeholder}
                    value={props.value}
                    error={error !== undefined}
                    onKeyDown={type === 'integer' ? handleKeyDown : undefined}
                    disabled={disabled}
                    className={`styleInput 
                ${error ? '!border-danger placeholder:text-danger' : disabled ? '!border-colorDisabled' : '!border-inputBorder'} 
                ${disabled ? 'cursor-text' : ''} 
                rounded-[4px] text-input pt-3 min-h-[40px] max-h-[40px] !border bg-white text-gray-900 shadow-lg 
                shadow-gray-900/5 ring-1 ring-transparent placeholder:text-gray-500 focus:!border-primary 
                focus:!border-t-primary focus:ring-white disabled:bg-white ${className ? className : ''}`}
                    containerProps={{className: "min-w-[50px]"}}
                    labelProps={{
                        className: "hidden",
                    }}
                    onChange={(e) => {
                        if (props.onChangeText) props.onChangeText(handleInputChange(e))
                    }}
                    style={{fontSize: `${textSize ? textSize : '$sizeText'}`}}
                />
                {error && <CustomTypography variant="small" style={{color: 'red'}}
                                            className={`static mt-[1px] font-normal ml-1 text-[10px] ${classNameError}`} text={error}/>}
            </div>
        </div>
    );
};

export default CustomInput;
